<div
    class="iframe-wrapper"
    [style.transform]="scaleTransform()"
>
    @if (trustedUrl) {
        <!--
            IMPORTANT: Do NOT add [style.width], [style.height], [width], or [height] bindings here.
            Dimensions are set via CSS (component SCSS) to ensure the iframe viewport is 1920x1080
            before any iframe content loads. Angular input bindings are applied after element creation
            via JavaScript, which can race with cached iframe scripts reading window.innerWidth — causing
            layout to be calculated with width=0 (black background, content piled at top-left).
            This fixes the iframe box only: the element is cross-origin, and a cached document can
            still start its scripts before this size reaches it (innerWidth and every vw are 0).
            Elements size their stage in CSS (pcp-html-elements-src/base.css) so layout heals once
            the size arrives; scripts that measure at load are not covered.
        -->
        <iframe
            #htmlElementFrame
            id="html-element-iframe"
            [src]="trustedUrl"
            [style.pointer-events]="disableElementUsage ? 'none' : 'auto'"
            width="1920"
            height="1080"
            (load)="onIframeLoaded(htmlElementFrame)"
        ></iframe>
    }
</div>
